import { c as _c } from "react/compiler-runtime";
import { Locale } from "modules/i18n/config/locale";
import { getRuntimeConfig } from "common/lib/runtimeConfig";
import { RefObject } from "react";
import ReCAPTCHA from "react-google-recaptcha";
const googleRecaptchaSiteKey = (): string => getRuntimeConfig().GOOGLE_RECAPTCHA_SITE_KEY;
const isEnvEnabled = (): boolean => process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_ENABLED == "true";
interface RecaptchaValidationProps {
  locale: Locale;
  recaptchaRef?: RefObject<ReCAPTCHA | null>;
}
export const RecaptchaValidation = t0 => {
  "use memo";

  const $ = _c(4);
  const {
    recaptchaRef,
    locale
  } = t0;
  if (!isEnvEnabled()) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = googleRecaptchaSiteKey();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== locale || $[2] !== recaptchaRef) {
    t2 = <ReCAPTCHA ref={recaptchaRef} hl={locale} sitekey={t1} size="invisible" />;
    $[1] = locale;
    $[2] = recaptchaRef;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};